var map = {
	"./404.svg": "sEM+",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./education.svg": "wyC6",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./guide.svg": "z74U",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./password.svg": "QjmH",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./search.svg": "Bx0U",
	"./shopping.svg": "jRi0",
	"./size.svg": "Cr4N",
	"./skill.svg": "NpjO",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tree-table.svg": "myHh",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 12